@if (check(); as cc) {
    <div class="flex flex-column gap-2">

        <!-- Verdict -->
        <div class="flex align-items-center gap-2 flex-wrap">
            @if (isOverridden()) {
                <p-tag severity="warn" icon="pi pi-unlock"
                       [value]="'QUOTE.CREDIT_CHECK.OVERRIDDEN' | translate" />
            } @else if (isApproved()) {
                <p-tag severity="success" icon="pi pi-check"
                       [value]="'QUOTE.CREDIT_CHECK.APPROVED' | translate" />
            } @else if (isStale()) {
                <p-tag severity="secondary" icon="pi pi-clock"
                       [value]="'QUOTE.CREDIT_CHECK.STALE' | translate" />
            } @else {
                <p-tag severity="danger" icon="pi pi-times"
                       [value]="'QUOTE.CREDIT_CHECK.DENIED' | translate" />
            }
            @if (cc.provider) {
                <span class="text-sm text-secondary">{{ cc.provider }}</span>
            }
        </div>

        <!-- Why it failed. Score and limit have different remedies, so name which one. -->
        @if (showDenialReasons() && !isApproved() && !isStale()) {
            <div class="text-sm text-red-600 flex flex-column gap-1">
                @if (deniedByScore()) {
                    <span>{{ "QUOTE.CREDIT_CHECK.DENIED_REASON_SCORE"
                        | translate: { score: cc.creditScore, minimum: cc.minimumCreditScore } }}</span>
                }
                @if (deniedByLimit()) {
                    <span>{{ "QUOTE.CREDIT_CHECK.DENIED_REASON_LIMIT" | translate: {
                        total: (currentTotal() | coreCurrency: cc.currencyCode),
                        limit: (cc.creditLimit | coreCurrency: cc.currencyCode)
                    } }}</span>
                }
            </div>
        }

        <div class="check-facts text-sm text-secondary flex flex-column gap-1 mt-2">
            <span>
                {{ "QUOTE.CREDIT_CHECK.SCORE" | translate }}: {{ cc.creditScore }}
                &middot;
                {{ "QUOTE.CREDIT_CHECK.LIMIT" | translate }}:
                {{ cc.creditLimit | coreCurrency: cc.currencyCode }}
            </span>

            <span>
                {{ "QUOTE.CREDIT_CHECK.CURRENT_TOTAL" | translate }}:
                {{ currentTotal() | coreCurrency: cc.currencyCode }}
            </span>

            @if (isApproved()) {
                <span>
                    {{ "QUOTE.CREDIT_CHECK.HEADROOM" | translate }}:
                    {{ headroom() | coreCurrency: cc.currencyCode }}
                </span>
            }

            @if (valueChangedSinceCheck()) {
                <span>
                    {{ "QUOTE.CREDIT_CHECK.CHECKED_VALUE" | translate }}:
                    {{ cc.checkedValue | coreCurrency: cc.currencyCode }}
                </span>
            }

            <span>
                {{ "QUOTE.CREDIT_CHECK.CHECKED_AT" | translate }}:
                {{ cc.checkedAtUtc | date: 'yyyy-MM-dd HH:mm' }}
                @if (cc.checkedBy) {
                    &middot; {{ cc.checkedBy }}
                }
            </span>

            @if (isOverridden()) {
                <span>
                    {{ "QUOTE.CREDIT_CHECK.OVERRIDDEN_BY" | translate }}: {{ cc.overriddenBy }}
                    @if (cc.overriddenAtUtc) {
                        &middot; {{ cc.overriddenAtUtc | date: 'yyyy-MM-dd HH:mm' }}
                    }
                </span>
            }
        </div>
    </div>
}
